module.exports = __webpack_public_path__ + "static/media/4D.89eaac32.png";